import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearInternalBackUrl} from "../config/crystalclear-internal-back-url";
import {Observable} from "rxjs";
import {ViewConfig} from "../../model/api/view-config";
import {ApiValidation} from "../../model/api/api-validation";
import {FieldResult} from "../../model/api/field-result";
import {WebTradeOrderView} from "../../model/internal/web-trade-order-view";
import {TradeOrderViewConfig} from "../../model/clearing/trade-order-view-config";
import {SimpleRequest} from "../../model/api/simple-request";

@Injectable({
  providedIn: 'root'
})
export class InternalTradeOrderViewService extends CommonCrudService<WebTradeOrderView> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearInternalBackUrl.GET_INTERNAL_TRADEORDERVIEW_LIST,
      CrystalclearInternalBackUrl.SAVE_INTERNAL_TRADEORDERVIEW,
      CrystalclearInternalBackUrl.DELETE_INTERNAL_TRADEORDERVIEW);
  }

  public getViews(): Observable<ApiValidation<WebTradeOrderView[]>> {
    return this.postStore(CrystalclearInternalBackUrl.GET_INTERNAL_TRADEORDERVIEW_VIEWS);
  }

  public saveAll(userViews: WebTradeOrderView[]): Observable<ApiValidation<any>> {
    return this.post(CrystalclearInternalBackUrl.SAVE_ALL_INTERNAL_TRADEORDERVIEW, userViews);
  }

  public getDefaultTemplate(): Observable<ApiValidation<string>> {
    return this.postStore(CrystalclearInternalBackUrl.GET_INTERNAL_DEFAULT_TEMPLATE);
  }

  public getTemplates(): Observable<ApiValidation<FieldResult<any>>> {
    return this.postStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATES);
  }

  public getTradeOrderTemplates(viewName: string): Observable<ApiValidation<TradeOrderViewConfig>> {
    return this.postStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATE_TRADEORDER, new SimpleRequest(viewName));
  }

  public getOrderTemplate(viewName: string): Observable<ApiValidation<ViewConfig>> {
    return this.postStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATE_ORDER, new SimpleRequest(viewName));
  }

  public getOrderPofTemplate(viewName: string): Observable<ApiValidation<ViewConfig>> {
    return this.postStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATE_ORDER_POF, new SimpleRequest(viewName));
  }

  public getTradeTemplate(viewName: string): Observable<ApiValidation<ViewConfig>> {
    return this.postStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATE_TRADE, new SimpleRequest(viewName));
  }

  public clearStorageViews(): void {
    this.clearStore(CrystalclearInternalBackUrl.GET_INTERNAL_TRADEORDERVIEW_VIEWS);
  }
  public clearStorage(): void {
    this.clearStore(CrystalclearInternalBackUrl.GET_INTERNAL_TRADEORDERVIEW_VIEWS);
    this.clearStore(CrystalclearInternalBackUrl.GET_INTERNAL_DEFAULT_TEMPLATE);
    this.clearStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATES);
    this.clearStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATE_TRADEORDER);
    this.clearStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATE_ORDER);
    this.clearStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATE_ORDER_POF);
    this.clearStore(CrystalclearInternalBackUrl.GET_INTERNAL_TEMPLATE_TRADE);
  }
}
